/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import {mergeClasses} from "../../../utils";

export const Label = ({ children, color, classes }) => {
    const classNames = [
        "label",
        color && "label-" + color,
        classes
    ];

    return <span className={mergeClasses(classNames)}>{children}</span>;
};



Label.colors = {
    secondary: "default"
};
